import React, { FC, useEffect, useState } from 'react';
import { useApplicationContext } from '../../../../../core/hooks/useApplicationContext';
import { BookingsGroup, TabTypes } from '../../../../../types';
import { BookingsListDataHooks } from '../../datahooks';
import { Accordion } from 'wix-ui-tpa/cssVars';
import { classes, st } from './BookingsList.st.css';
import { renderBookingDetails } from './BookingDetails';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import { useGroupHeaderGetters } from '../../../../../core/hooks/useGroupHeaderGetter';
import { groupLimit } from '../../../../../consts/limit';
import { LimitIndicator } from './LimitIndicator';

export const BookingsList: FC = () => {
  const { upcomingData, historyData, selectedTab } = useApplicationContext();
  const { t } = useTranslation();
  const { isMobile } = useEnvironment();
  const { getTitle, getSubtitle } = useGroupHeaderGetters();

  const data =
    selectedTab.type === TabTypes.UPCOMING ? upcomingData : historyData;

  const [dataToShow, setDataToShow] = useState<BookingsGroup[]>(
    data!.groups.slice(0, groupLimit),
  );

  useEffect(() => {
    setDataToShow(data!.groups.slice(0, groupLimit));
  }, [data?.groups.length]);

  return (
    <div className={classes.root} data-hook={BookingsListDataHooks.Main}>
      <Accordion
        className={st(classes.accordion, { isMobile })}
        data-hook={BookingsListDataHooks.Accordion}
      >
        {dataToShow.map((group) =>
          renderBookingDetails({
            group,
            t,
            isMobile,
            selectedTab,
            title: getTitle(group),
            subtitle: getSubtitle(group),
          }),
        )}
      </Accordion>
      {data!.groups.length > groupLimit && <LimitIndicator />}
    </div>
  );
};
